"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoTitleError = exports.stringifyCircular = void 0;
var traverse_1 = __importDefault(require("@json-schema-tools/traverse"));
var deleteAllProps = function (o) {
    Object.keys(o)
        .forEach(function (k) { delete o[k]; });
};
var stringifyCircular = function (obj) {
    var cache = [];
    return JSON.stringify(obj, function (key, value) {
        if (typeof value === "object" && value !== null) {
            if (cache.indexOf(value) !== -1) {
                return "[Circular: " + (value.title ? value.title : "NoTitle") + "]";
            }
            cache.push(value);
        }
        return value;
    }, "\t");
};
exports.stringifyCircular = stringifyCircular;
var NoTitleError = /** @class */ (function () {
    function NoTitleError(schema, parentSchema) {
        this.name = "NoTitleError";
        var schemaStr;
        var parentSchemaStr;
        try {
            schemaStr = JSON.stringify(schema);
        }
        catch (e) {
            schemaStr = exports.stringifyCircular(schema);
        }
        try {
            parentSchemaStr = JSON.stringify(parentSchema);
        }
        catch (e) {
            parentSchemaStr = exports.stringifyCircular(parentSchema);
        }
        this.message = [
            "Title is required on subschemas.",
            "Without title, identical schemas would return differing names.",
            "",
            "Subschema in question:",
            schemaStr,
            "",
            "Parent Schema:",
            parentSchemaStr,
        ].join("\n");
    }
    return NoTitleError;
}());
exports.NoTitleError = NoTitleError;
/**
 * Returns the schema where all subschemas have been replaced with $refs and added to definitions.
 *
 * All of the subschemas must have a title. If you are unsure if you have titles for all
 * schemas, use the json-schema-tools/titleizer first. If a subschema is already a $ref, it must
 * exists in the input schema's definitions object.
 *
 * @param s The schema to create references for (ie 'flatten' it)
 *
 * @returns input schema where subschemas are turned into refs (recursively)
 *
 * @category Utils
 * @category SchemaImprover
 *
 */
function referencer(s) {
    var definitions = {};
    traverse_1.default(s, function (subSchema, isRootCycle) {
        var t = "";
        if (isRootCycle && subSchema !== true && subSchema !== false) {
            if (subSchema.$ref) {
                var title = subSchema.$ref.replace("#/definitions/", "");
                var hasDefForRef = definitions[title];
                if (hasDefForRef === undefined) {
                    throw new Error("Encountered unknown $ref: " + subSchema.$ref);
                }
                return subSchema;
            }
            if (subSchema === s) {
                definitions[s.title] = { $ref: "#" };
                return { $ref: "#/definitions/" + s.title };
            }
            definitions[subSchema.title] = __assign({}, subSchema);
            deleteAllProps(subSchema);
            subSchema.$ref = "#/definitions/" + subSchema.title;
            return subSchema;
        }
        if (subSchema === true) {
            t = "AlwaysTrue";
            definitions[t] = true;
        }
        else if (subSchema === false) {
            t = "AlwaysFalse";
            definitions[t] = false;
        }
        else if (subSchema.$ref !== undefined && subSchema.$ref.indexOf("#") !== -1) {
            return subSchema;
        }
        else {
            if (typeof subSchema.title !== "string") {
                throw new NoTitleError(subSchema, s);
            }
            t = subSchema.title;
            definitions[t] = __assign({}, subSchema);
            deleteAllProps(subSchema);
            subSchema.$ref = "#/definitions/" + t;
        }
        return subSchema;
    }, { mutable: true, skipFirstMutation: true });
    if (typeof s === "object" && Object.keys(definitions).length > 0) {
        s.definitions = __assign(__assign({}, s.definitions), definitions);
    }
    return s;
}
exports.default = referencer;
